"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionContent = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var AccordionContent = function (props) {
    var className = props.className, children = props.children, hasPictogram = props.hasPictogram, id = props.id, targetHeaderId = props.targetHeaderId, 
    // tslint:disable-next-line: trailing-comma
    restProps = __rest(props, ["className", "children", "hasPictogram", "id", "targetHeaderId"]);
    var ariaAttrs = {};
    ariaAttrs['aria-labelledby'] = targetHeaderId;
    ariaAttrs.role = 'region';
    var classNames = (0, classnames_1.default)('accordion-content', className !== null && className !== void 0 ? className : className, { 'withpictogram': hasPictogram });
    return (React.createElement("div", __assign({ id: id, className: classNames }, ariaAttrs, restProps), children));
};
exports.AccordionContent = AccordionContent;
/* tslint:disable:no-string-literal */
exports.AccordionContent['propTypes'] = {
    className: PropTypes.string,
    hasPictogram: PropTypes.bool,
    id: PropTypes.string.isRequired,
    targetHeaderId: PropTypes.string.isRequired,
};
exports.AccordionContent['defaultProps'] = {
    className: '',
};
/* tslint:enable:no-string-literal */
